import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_BANNERS = "fetchAdminBanners";
export const FETCH_ADMIN_BANNER = "fetchAdminBanner";
export const STORE_ADMIN_BANNER = "storeAdminBanner";
export const UPDATE_ADMIN_BANNER = "updateAdminBanner";
export const DESTROY_ADMIN_BANNER = "destroyAdminBanner";

// mutation types
export const SET_ADMIN_BANNERS = "setAdminBanners";
export const SET_ADMIN_BANNERS_PAGINATION = "setAdminBannersPagination";
export const SET_ADMIN_BANNER = "setAdminBanner";

const state = {
  adminBanners: [],
  adminBannersPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  adminBanner: {}
};

const getters = {
  adminBanners(state) {
    return state.adminBanners;
  },
  adminBannersPagination(state) {
    return state.adminBannersPagination;
  },
  adminBanner(state) {
    return state.adminBanner;
  }
};

const actions = {
  [FETCH_ADMIN_BANNERS](context) {
    let params = {
      page: context.state.adminBannersPagination.currentPage
    };

    return new Promise((resolve, reject) => {
      ApiService.query("admin/banners", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_BANNERS, data.data);
          context.commit(SET_ADMIN_BANNERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_BANNER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query("profile", {
        params: {
          banner: id
        }
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_BANNER, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_ADMIN_BANNER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("admin/banners", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_ADMIN_BANNER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("profile", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_ADMIN_BANNER](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`admin/banners/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  }
};

const mutations = {
  [SET_ADMIN_BANNERS](state, adminBanners) {
    state.adminBanners = adminBanners;
  },
  [SET_ADMIN_BANNERS_PAGINATION](state, data) {
    state.adminBannersPagination = data;
  },
  [SET_ADMIN_BANNER](state, adminBanner) {
    state.adminBanner = adminBanner;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
